import { handleActions } from 'redux-actions';

import { NAMES as PAGINATED_CHANNEL_VIDEOS } from 'widget/redux/client/actions/paginated-channel-videos';
import { NAMES as CHANNEL_VIDEOS_LIST } from 'shared/redux/server/actions/channel/videos/list-public';

// TODO: refactor

let options = {
  perUIPage: 4,
  currentUIPage: 0,
};

/*
 TODO: deprecate this structure, instead use:
  {
    idChunks: [],
    currentUIPage: 0,
    loadedUIPagesCount: 0,
  }
 */
const paginatedVideos = {
  idChunks: [],
  ids: [],
  prevPageIds: [],
  nextPageIds: [],
  currentUIPage: 0,
  loadedUIPagesCount: 0,
};

function update(state, { payload = {} }) {
  options = { ...options, ...payload };
  const { currentUIPage } = options;

  return {
    ...state,
    currentUIPage,
    ids: state.idChunks[currentUIPage] || [],
    prevPageIds: state.idChunks[currentUIPage - 1] || [],
    nextPageIds: state.idChunks[currentUIPage + 1] || [],
    loadedUIPagesCount: state.idChunks.length,
  };
}

function saveIds(state, { payload }) {
  const { perUIPage } = options;
  const ids = payload.response.data.result;

  const idChunks = _(state.idChunks)
    .flatten()
    .concat(ids)
    .uniq()
    .chunk(perUIPage)
    .value();

  return update({
    ...state,
    idChunks,
  }, {});
}

function reset(state, { payload }) {
  const { perUIPage } = payload;

  return update({
    ...state,
    idChunks: [],
  }, {
    payload: {
      currentUIPage: 0,
      perUIPage,
    },
  });
}

export default handleActions({
  [PAGINATED_CHANNEL_VIDEOS.UPDATE]: update,
  [CHANNEL_VIDEOS_LIST.SUCCESS]: saveIds,
  [PAGINATED_CHANNEL_VIDEOS.RESET]: reset,
}, paginatedVideos);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/paginated-channel-videos.js